// keep-popover-open-on-select-min.directive.ts
import { Directive, OnDestroy, Host } from '@angular/core';
import { Select } from 'primeng/select';

@Directive({
  selector: 'p-select[stopOnOptionSelectPropagation]',
  standalone: true
})
export class StopOnOptionSelectPropagationDirective implements OnDestroy {
  private restore?: () => void;

  constructor(@Host() select: Select) {
    const orig = select.onOptionSelect.bind(select);

    (select as any).onOptionSelect = (event: any, option: any, isHide = true, preventChange = false) => {
      // Stop the “option click” from reaching document listeners (e.g., p-popover outside click)
      try { event?.stopImmediatePropagation?.(); } catch {}
      try { event?.stopPropagation?.(); } catch {}
      return orig(event, option, isHide, preventChange);
    };

    this.restore = () => ((select as any).onOptionSelect = orig);
  }

  ngOnDestroy() {
    try { this.restore?.(); } catch {}
  }
}